export default {
  api: process.env.VUE_APP_API_URL,
  socket: process.env.VUE_APP_SOCKET_URL,
  version: process.env.VUE_APP_VERSION
}
